import { isBoostPlayerBonus } from "./typeGuards";
export function getCashOutDisclaimer(cashOut, playerBonus, dictionary) {
    let result = "";
    if (Boolean(cashOut)) {
        if ((playerBonus === null || playerBonus === void 0 ? void 0 : playerBonus.type) === "GUARANTEED_PAYOUT") {
            return dictionary.myBetsDictionary.GhostLegActive;
        }
        if (isBoostPlayerBonus(playerBonus)) {
            result = dictionary.myBetsDictionary.CashOutBonusDisclaimer;
        }
        if ((playerBonus === null || playerBonus === void 0 ? void 0 : playerBonus.type) === "EARLY_WIN") {
            result = dictionary.myBetsDictionary.CashOutEarlyWinDisclaimer;
        }
        if ((playerBonus === null || playerBonus === void 0 ? void 0 : playerBonus.type) === "QUALIFYING_BET") {
            result = dictionary.myBetsDictionary.CashOutQualifyingBetDisclaimer;
        }
    }
    return result;
}
//# sourceMappingURL=getCashOutDisclaimer.js.map